import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ADMIN_ROLE_SLUG, OPERATIVE_ROLE_SLUG } from '~/Constants'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import i18n from '~/components/i18n'
import { useAuth } from '~/routes/components/AuthProvider'
import { El as LayoutEl } from '~/components/Layout/style';
import notify from '~/components/Notify'
import Dialog from '~/components/Dialog'
import { Popup } from 'semantic-ui-react'
import CustomIcon from '~/components/CustomIcon'
import CreateEditMembershipStatuses from './CreateEditMembershipStatuses'

const getTableColumns = () => [
  {
    name: i18n.t('Designation'),
    key: 'name'
  },
  {
    name: i18n.t('Actions')
  }
];

const MembershipStatuses: React.FC = () => {
  const { t } = useTranslation()
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const displayAction = roleSlug === ADMIN_ROLE_SLUG || roleSlug === OPERATIVE_ROLE_SLUG
  const [drawer, setDrawerState] = useState({
    isVisible: false,
    id: null
  })
  const [selectedStatus, setSelectedStatus] = useState(null)
  const actions = [
    {
      popupMessage: i18n.t('Edit'),
      type: 'icon',
      name: 'pencil',
      size: 'large',
      actionType: 'edit',
      displayedText: i18n.t('No actions')
    },
    {
      popupMessage: i18n.t('Delete'),
      type: 'icon',
      name: 'trash',
      size: 'large',
      actionType: 'delete',
      displayedText: i18n.t('No actions'),
      renderActions: getAction
    }
  ]

  function getAction(row, type) {
    return <Popup
      content={t('Delete')}
      trigger={<CustomIcon
        size='large'
        style={{ marginBottom: 2 }}
        onClick={() => setSelectedStatus(row)}
        name='trash' />}
    />
  }

  const onSuccess = () => {
    notify(t('Successfully deleted membership status'), 'success');
    fetchData();
  };

  const {
    isLoading: isBusyData,
    data: membershipStatuses,
    refetch: fetchData
  } = DairyQuery.getMembershipStatusesList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { isLoading: isStateDeleteLoading, mutate: deleteMembershipStatus } = DairyQuery.deleteMembershipStatus(
    onSuccess
  );

  async function onStatusDelete() {
    deleteMembershipStatus(selectedStatus?.id)
    setSelectedStatus(null)
  }

  function handleActionClick(row, type) {
    switch (type) {
      case 'edit':
        return setDrawerState({ isVisible: true, id: row?.id })
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={getTableColumns()}
      rows={membershipStatuses || []}
      total={membershipStatuses.length || 0}
      handleClickAction={handleActionClick}
      removePagination
      actions={displayAction ? actions : []}
    />
  }

  function renderActions() {
    return <LayoutEl.PageHeaderActionButton
      onClick={() => setDrawerState({ isVisible: true, id: null })}
    >{t('Add new membership status')}</LayoutEl.PageHeaderActionButton>
  }

  function renderEditCreateState() {
    return <CreateEditMembershipStatuses
      isVisible={drawer.isVisible}
      idMembershipStatus={drawer.id}
      fetchData={fetchData}
      handleHiddenDrawer={() => setDrawerState({ isVisible: false, id: null })}
    />
  }

  function renderDeleteModal() {
    return <Dialog
      key='dialog-membership-status-delete'
      textHeader={t(`Delete membership status: ${selectedStatus?.name}`)}
      textClose={t('Close')}
      textContent={t('Are you sure that you want to delete {{name}} membership status?', { name: selectedStatus?.name })}
      textSubmit={t('Delete membership status')}
      handleClose={() => setSelectedStatus(null)}
      handleSubmit={onStatusDelete}
      type='abort'
      isDialogOpen={Boolean(selectedStatus)}
      isLoading={isStateDeleteLoading}
    />
  }

  return <Layout
    title={t('Membership Statuses')}
    isBusy={isBusyData}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    actions={displayAction && renderActions()}
    useSpinner
  >
    {selectedStatus && renderDeleteModal()}
    {renderEditCreateState()}
    {membershipStatuses && renderTable()}
  </Layout>
}
export default MembershipStatuses
